import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import moment from "moment";
// -
import DateTimesUtils from "core/utils/DateTimesUtils";
import ButtonsDays from "components/datestimes/ButtonsDays";
import { ProgrammingModel } from "site-apps/distribution/programming/ProgrammingModel";


const FormProgramming = (
    { thing = { ...ProgrammingModel }, setThing, days, setDays, optionsShown, setOptionsShown, option, setOption, inputRefs }
) => {
    const [_Tf] = useTranslation("forms");
    const [_Td] = useTranslation("datestimes");
    const dates = useRef({
        start: null,
        end: null,
    })
    useEffect(() => {
        let item_ = { ...thing };
        if (item_.date_start) {
            dates.current.start = moment(item_.date_start, "YYYY-MM-DD");
            item_.date_start = dates.current.start.format("YYYY-MM-DD");
            dates.current.end = item_.date_end ? moment(item_.date_end, "YYYY-MM-DD") : "";
        } else {
            dates.current.start = moment();
            item_.date_start = dates.current.start.format("YYYY-MM-DD");
        }
        item_.date_end = dates.current.end ? dates.current.end.format("YYYY-MM-DD") : "";
        if (item_.is_periodic) {
            switch (item_.repeat) {
                case "w":
                    setDays(item_.values.days);
                    break;
                case "m":
                case "y":
                    calculateOptions(item_.repeat);
                    switch (item_.values.type) {
                        case "d":
                            setOption("0");
                            break;
                        case "n":
                            setOption("1");
                            break;
                        case "p":
                            setOption("2");
                            break;
                        default:
                    }
                    break;
                default:
            }
        }
        setThing(item_);
    }, [])


    const handleChange = (e) => {
        const { name, type } = e.target;
        let value = type === "checkbox" ? e.target.checked : e.target.value;
        let item_ = { ...thing };
        item_[name] = value;
        switch (name) {
            case "date_start":
                dates.current.start = moment(value, "YYYY-MM-DD");
                item_.is_periodic && ["m", "y"].includes(item_.repeat) && calculateOptions(item_.repeat)
                break;
            case "is_periodic":
                item_.every = 1;
                item_.repeat = "w";
                break;
            case "repeat":
                calculateOptions(value);
                break;
            default:
        }
        setThing(item_);
    }

    const calculateOptions = (repeat) => {
        setOptionsShown([]);
        setDays([])
        setOption("0");
        let options_ = [];
        let day, dayPlace, weekday, dayName;
        day = dates.current.start.format("D");
        switch (repeat) {
            case "m": // month
                options_.push({ id: "0", day: day, value: 0, type: "d", title: `El día ${day}` })
                dayPlace = DateTimesUtils.dayMonthPlace(dates.current.start.format("YYYY-MM-DD"));
                weekday = dates.current.start.format("d");
                dayName = _Td("days_name." + weekday);
                options_.push({
                    id: "1", day: weekday, value: dayPlace, type: "n",
                    title: `${_Td("the_place." + dayPlace)} ${dayName.toLowerCase()}`
                })
                if (dayPlace >= 4) {
                    options_.push({
                        id: "2", day: weekday, value: "last", type: "p",
                        title: `${_Td("the_place.last")} ${dayName.toLowerCase()}`,
                    })
                }
                break;
            case "y": // years
                let month = dates.current.start.format("M");
                options_.push({ id: "0", day: day, value: month, type: "d", title: `El ${day} de ${_Td("months_name." + month)}` })
                dayPlace = DateTimesUtils.dayMonthPlace(dates.current.start.format("YYYY-MM-DD"));
                weekday = dates.current.start.format("d");
                dayName = _Td("days_name." + weekday);
                options_.push({
                    id: "1", day: weekday, value: month, place: dayPlace, type: "n",
                    title: `${_Td("the_place." + dayPlace)} ${dayName.toLowerCase()} de ${_Td("months_name." + month)}`
                })
                if (dayPlace >= 4) {
                    options_.push({
                        id: "2", day: weekday, value: month, place: "last", type: "p",
                        title: `${_Td("the_place.last")} ${dayName.toLowerCase()} de ${_Td("months_name." + month)}`
                    })
                }
                break;
            default:
        }
        setOptionsShown(options_);
    }

    const handleOptions = (e) => {
        const { value } = e.target;
        setOption(value)
    }

    return (
        <div className="container-fluid">
            <div className="row g-3 mb-5 pb-5">
                <div className="col-12">
                    <div className="row g-3 align-items-center">
                        <div className="col-3">
                            <label htmlFor="name"
                                className="col-form-label">{_Tf("common.name")}*</label>
                        </div>
                        <div className="col-9">
                            <input type="text" className="form-control" id="name" name="name"
                                value={thing.name}
                                onChange={handleChange}
                                required
                                ref={(el) => (inputRefs.current.name = el)}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-3">
                            <label htmlFor="description"
                                className="col-form-label">{_Tf("common.description")}</label>
                        </div>
                        <div className="col-9">
                            <textarea className="form-control" rows="4"
                                id="description" name="description"
                                value={thing.description}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-3">
                            <label htmlFor="type"
                                className="col-form-label">{_Tf("common.type")}</label>
                        </div>
                        <div className="col-9">
                            <Form.Select className="mb-2"
                                id="type"
                                name="type"
                                value={thing.type}
                                onChange={handleChange}
                                style={{ maxWidth: "130px" }}
                            >
                                <option value="o">{_Tf("programming.ordinary")}</option>
                                <option value="e">{_Tf("programming.extraordinary")}</option>
                            </Form.Select>
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-3">
                            <label htmlFor="date_start"
                                className="col-form-label">{_Tf("programming.start_date")}*</label>
                        </div>
                        <div className="col-3">
                            <input type="date" className="form-control" id="date_start" name="date_start"
                                value={thing.date_start}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-3 text-end">
                            <label htmlFor="date_end"
                                className="col-form-label">{_Tf("programming.end_date")}</label>
                        </div>
                        <div className="col-3">
                            <input type="date" className="form-control" id="date_end" name="date_end"
                                value={thing.date_end || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-3">
                            <label htmlFor="compile"
                                className="col-form-label">{_Tf("programming.hour-prog")}*</label>
                        </div>
                        <div className="col-3">
                            <input type="time" className="form-control" id="compile" name="compile"
                                value={thing.compile}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-3 text-end">
                            <label htmlFor="run"
                                className="col-form-label">{_Tf("programming.hour-prog-start")}*</label>
                        </div>
                        <div className="col-3">
                            <input type="time" className="form-control" id="run" name="run"
                                value={thing.run}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <hr className="mt-5 mb-4" />
                    <div className="row g-3 align-items-center mt-3">
                        <div className="form-check form-switch d-flex justify-content-center">
                            <input type="checkbox" id="is-periodic" className="form-check-input"
                                checked={thing.is_periodic}
                                onChange={handleChange}
                                name="is_periodic"
                            />
                            <label title="Hacer periódico" htmlFor="is-periodic" className="form-check-label ms-3">{_Tf("programming.periodic")}</label>
                        </div>
                    </div>
                </div>
                {
                    thing.is_periodic ?
                        <div className="col-12">
                            <div className="row">
                                <div className="col">
                                    <div className="row g-3 align-items-center mt-3">
                                        <div className="col-3">
                                            <label htmlFor="every"
                                                className="col-form-label">Repetir cada</label>
                                        </div>
                                        <div className="col-9 mb-2">
                                            <input type="number" className="form-control text-end d-inline-block me-2"
                                                id="every" name="every"
                                                min="0"
                                                max="100"
                                                value={thing.every}
                                                onChange={handleChange}
                                                style={{ maxWidth: "100px" }}
                                            />
                                            <Form.Select className="d-inline-block"
                                                id="repeat"
                                                name="repeat"
                                                value={thing.repeat}
                                                onChange={handleChange}
                                                style={{ maxWidth: "130px" }}
                                            >
                                                <option value="d">Días</option>
                                                <option value="w">Semanas</option>
                                                <option value="m">Meses</option>
                                                <option value="y">Años</option>
                                            </Form.Select>

                                        </div>

                                    </div>
                                </div>

                            </div>
                            {
                                thing.repeat === "w"
                                    ? <div className="row mt-5 text-center">
                                        <div className="col-12">
                                            <h5>{_Tf("alert-setups.days")}</h5>
                                        </div>
                                        <ButtonsDays days={days} setDays={setDays} display={true} />
                                    </div>
                                    : <></>
                            }
                            {
                                optionsShown.length > 0
                                    ?
                                    optionsShown.map((_option, index) => (
                                        <div className="row mt-3" key={index}>
                                            <div className="col-3"></div>
                                            <div className="col-9">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="options"
                                                        id={_option.id} value={_option.id}
                                                        checked={_option.id === option}
                                                        onChange={handleOptions}
                                                    />
                                                    <label className="form-check-label" htmlFor={_option.id}>
                                                        {_option.title}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ))

                                    : <></>
                            }
                        </div>
                        : <></>
                }
            </div>
        </div>
    )
}


export default FormProgramming;
